module.exports = __webpack_public_path__ + "static/media/icon-users.9e74b827.svg";